import { render } from "./EmailSet.vue?vue&type=template&id=ada1a4a4&ts=true&lang=pug"
import script from "./EmailSet.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailSet.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__